export default __webpack_public_path__ + "static/media/bg-Logo-Blue.e113c71f.png";